import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import { ApolloClient, ApolloQueryResult } from 'apollo-client';
import { ApolloLink, GraphQLRequest } from 'apollo-link';
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import { RetryLink } from 'apollo-link-retry';
import { DocumentNode } from 'graphql';
import accounts from '@/helpers/accountsIframe';

const uri = process.env.VUE_APP_CHIMERA_GRAPHQL;

export const mountContext = (_: GraphQLRequest, { headers }: any) => {
  const authToken = accounts.getTokenD();

  const authorization = authToken ? `Bearer ${authToken.replace(/"/g, '')}` : undefined;

  return { headers: { ...headers, authorization } };
};

const chimeraAuthLink = setContext(mountContext);

export function getChimeraApolloClient(): ApolloClient<NormalizedCacheObject> {
  const link = ApolloLink.from([new RetryLink(), chimeraAuthLink, createHttpLink({ uri })]);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
    connectToDevTools: process.env.NODE_ENV === 'development',
    defaultOptions: { query: { fetchPolicy: 'no-cache' } },
  });
}

export async function query<T>(
  query: DocumentNode,
  variables?: Record<string, any>,
): Promise<ApolloQueryResult<T>> {
  const apolloClient = getChimeraApolloClient();

  return apolloClient.query<T>({
    query,
    variables,
  });
}
